import { AuthenticateErrorEnum } from '../enums/authenticate.enum';

export const forgotPasswordErrorMap: ReadonlyMap<string | undefined, string> = new Map<AuthenticateErrorEnum, string>([
  [AuthenticateErrorEnum.CODE_MISMATCH_EXCEPTION, 'Invalid verification code provided, please try again.'],
  [AuthenticateErrorEnum.LIMIT_EXCEEDED_EXCEPTION, 'Attempt limit exceeded, please try after some time.'],
]);

export const SKIP_AUTH_HEADER = "X-Skip-Authorization"
